import { createContext, PropsWithChildren, useState } from "react";
import { BridgeEnv, TransferFlow } from "../typings";

export type AppProviderValue = ReturnType<typeof CreateProviderValue>;

export const CreateProviderValue = () => {
  const [isConfig, setIsConfig] = useState<boolean>(false);
  const [appEnv, setAppEnv] = useState<BridgeEnv>();
  const [isWebview, setIsWebview] = useState<boolean>(false);
  const [isAppLoading, setIsAppLoading] = useState<boolean>(true);
  const [partnerConfig, setPartnerConfig] = useState<string>();
  const [transferFlow, setTransferFlow] = useState<TransferFlow>();
  const [transferIntentId, setTransferIntentId] = useState<string>("");
  const [accessToken, setAccessToken] = useState<string>("");
  const [transferId, setTransferId] = useState<number | string>();
  const [clientId, setClientId] = useState<string>("");

  return {
    appEnv,
    setAppEnv,
    isConfig,
    setIsConfig,
    isAppLoading,
    setIsAppLoading,
    partnerConfig,
    setPartnerConfig,
    transferFlow,
    setTransferFlow,
    transferIntentId,
    setTransferIntentId,
    accessToken,
    setAccessToken,
    transferId,
    setTransferId,
    clientId,
    setClientId,
    isWebview,
    setIsWebview,
  };
};

export const AppContext = createContext({} as AppProviderValue);

const AppProvider = (props: PropsWithChildren<any>) => {
  const providerValue = CreateProviderValue();
  return <AppContext.Provider value={providerValue}>{props.children}</AppContext.Provider>;
};

export default AppProvider;
